'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="w-full" style={{ background: '#050510', borderBottom: '2px solid #00f5ff', boxShadow: '0 2px 20px rgba(0,245,255,0.2)', position: 'relative', zIndex: 500 }}>
      {/* Top utility bar — hidden on mobile */}
      <div
        className="hidden sm:block"
        style={{
          background: '#0d0d2b',
          borderBottom: '1px solid #1a1a4e',
          padding: '8px 16px'
        }}>

        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5">
              <span
                style={{
                  display: 'inline-block',
                  width: '7px',
                  height: '7px',
                  borderRadius: '50%',
                  background: '#00f5ff',
                  boxShadow: '0 0 10px #00f5ff, 0 0 20px rgba(0,245,255,0.5)'
                }} />

              <span
                style={{
                  fontFamily: 'Barlow Condensed, Arial, sans-serif',
                  fontWeight: 700,
                  fontSize: '11px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.12em',
                  color: '#00f5ff',
                  textShadow: '0 0 8px rgba(0,245,255,0.6)'
                }}>

                Launching Soon · Mesquite, NV
              </span>
            </div>
            <span style={{ color: 'rgba(0,245,255,0.2)', fontSize: '10px' }}>|</span>
            <span
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 600,
                fontSize: '11px',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: 'rgba(224,232,255,0.45)'
              }}>

              Las Vegas · Mesquite · St. George
            </span>
          </div>
          <Link
            href="/admin"
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 700,
              fontSize: '11px',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              color: 'rgba(224,232,255,0.35)',
              textDecoration: 'none',
              transition: 'color 0.15s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#00f5ff'}
            onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(224,232,255,0.35)'}>

            Admin
          </Link>
        </div>
      </div>

      {/* Main header */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 md:py-5 flex items-center justify-between gap-3">
        {/* Left: logo + brand name */}
        <Link href="/home" className="flex items-center gap-2 md:gap-5" style={{ textDecoration: 'none' }}>
          <div
            style={{
              width: '44px',
              height: '44px',
              flexShrink: 0,
              border: '2px solid #00f5ff',
              overflow: 'hidden',
              boxShadow: '0 0 16px rgba(0,245,255,0.3)'
            }}>

            <AppImage
              src="/assets/images/vertex_premium-1786291409058.jpg"
              alt="Vertex Premium Mobile Detailing logo"
              width={44}
              height={44}
              className="w-full h-full object-cover" />

          </div>
          <div>
            <div className="flex items-baseline gap-0 leading-none">
              <span
                style={{
                  fontFamily: 'Barlow Condensed, Arial Narrow, Arial, sans-serif',
                  fontWeight: 900,
                  fontSize: 'clamp(28px, 6vw, 64px)',
                  textTransform: 'uppercase',
                  letterSpacing: '-0.01em',
                  color: '#e0e8ff',
                  lineHeight: 0.9,
                  display: 'block',
                  textShadow: '0 0 30px rgba(0,245,255,0.3)'
                }}>

                VERTEX
              </span>
            </div>
            <div className="flex items-center gap-1.5 mt-0.5">
              <span
                style={{
                  fontFamily: 'Barlow Condensed, Arial Narrow, Arial, sans-serif',
                  fontWeight: 900,
                  fontSize: 'clamp(9px, 1.8vw, 16px)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.18em',
                  color: '#050510',
                  background: 'linear-gradient(90deg, #00f5ff, #7b2fff)',
                  padding: '2px 6px',
                  display: 'inline-block'
                }}>

                PREMIUM
              </span>
              <span
                className="hidden sm:inline"
                style={{
                  fontFamily: 'Barlow Condensed, Arial Narrow, Arial, sans-serif',
                  fontWeight: 700,
                  fontSize: 'clamp(9px, 1.5vw, 14px)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.14em',
                  color: '#7b8ab8'
                }}>

                MOBILE DETAILING
              </span>
            </div>
          </div>
        </Link>

        {/* Right: nav + CTA + hamburger */}
        <div className="flex items-center gap-2 md:gap-5">
          {/* Nav links — desktop only */}
          <nav className="hidden md:flex items-center gap-6">
            {[
            { label: 'Services', href: '/home#pricing' },
            { label: 'About', href: '/about' },
            { label: 'FAQ', href: '/home#faq' },
            { label: 'Reviews', href: '/reviews' },
            { label: 'Contact', href: '/home#waitlist' }]?.
            map((link) =>
            <a
              key={link?.label}
              href={link?.href}
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 700,
                fontSize: '14px',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: '#a0b0d8',
                textDecoration: 'none',
                transition: 'color 0.15s ease, text-shadow 0.15s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#00f5ff';
                e.currentTarget.style.textShadow = '0 0 10px rgba(0,245,255,0.6)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#a0b0d8';
                e.currentTarget.style.textShadow = 'none';
              }}>

                {link?.label}
              </a>
            )}
          </nav>

          {/* Waitlist CTA — desktop only */}
          <Link
            href="/waitlist"
            className="hidden sm:inline-flex"
            style={{
              fontFamily: 'Barlow Condensed, Arial Narrow, Arial, sans-serif',
              fontWeight: 900,
              fontSize: '13px',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: '#050510',
              background: '#00f5ff',
              border: '2px solid #00f5ff',
              padding: '10px 20px',
              textDecoration: 'none',
              alignItems: 'center',
              gap: '6px',
              transition: 'background 0.15s ease, box-shadow 0.15s ease',
              whiteSpace: 'nowrap',
              boxShadow: '0 0 16px rgba(0,245,255,0.4)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#40faff';
              e.currentTarget.style.boxShadow = '0 0 28px rgba(0,245,255,0.7)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#00f5ff';
              e.currentTarget.style.boxShadow = '0 0 16px rgba(0,245,255,0.4)';
            }}>

            <span style={{ fontSize: '12px' }}>★</span>
            Join Waitlist
          </Link>

          {/* Hamburger — mobile only */}
          <button
            className="md:hidden flex flex-col items-center justify-center gap-1"
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              width: '40px',
              height: '40px',
              background: menuOpen ? 'rgba(0,245,255,0.1)' : 'transparent',
              border: `1px solid ${menuOpen ? '#00f5ff' : 'rgba(0,245,255,0.3)'}`,
              cursor: 'pointer',
              padding: '10px',
              transition: 'all 0.2s ease',
              flexShrink: 0
            }}
            aria-label="Toggle menu">

            <span
              style={{
                display: 'block',
                width: '18px',
                height: '2px',
                background: '#00f5ff',
                transition: 'transform 0.25s ease, opacity 0.25s ease',
                transform: menuOpen ? 'translateY(4px) rotate(45deg)' : 'none',
                boxShadow: '0 0 6px rgba(0,245,255,0.6)'
              }} />

            <span
              style={{
                display: 'block',
                width: '18px',
                height: '2px',
                background: '#00f5ff',
                transition: 'opacity 0.25s ease',
                opacity: menuOpen ? 0 : 1,
                boxShadow: '0 0 6px rgba(0,245,255,0.6)'
              }} />

            <span
              style={{
                display: 'block',
                width: '18px',
                height: '2px',
                background: '#00f5ff',
                transition: 'transform 0.25s ease, opacity 0.25s ease',
                transform: menuOpen ? 'translateY(-4px) rotate(-45deg)' : 'none',
                boxShadow: '0 0 6px rgba(0,245,255,0.6)'
              }} />

          </button>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      <div
        className="md:hidden overflow-hidden"
        style={{
          maxHeight: menuOpen ? '500px' : '0',
          transition: 'max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          background: '#0d0d2b',
          borderTop: menuOpen ? '1px solid rgba(0,245,255,0.2)' : 'none'
        }}>

        <div style={{ padding: '16px' }}>
          {/* Status in mobile menu */}
          <div className="flex items-center gap-2 mb-4 pb-3" style={{ borderBottom: '1px solid #1a1a4e' }}>
            <span style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', background: '#00f5ff', boxShadow: '0 0 8px #00f5ff', flexShrink: 0 }} />
            <span style={{ fontFamily: 'Barlow Condensed, Arial, sans-serif', fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.1em', color: '#00f5ff' }}>
              Now Booking · Mesquite, NV
            </span>
          </div>

          {/* Nav links */}
          <nav className="flex flex-col gap-1 mb-4">
            {[
            { label: 'Services & Pricing', href: '/home#pricing' },
            { label: 'About', href: '/about' },
            { label: 'FAQ', href: '/home#faq' },
            { label: 'Reviews', href: '/reviews' },
            { label: 'Get a Quote', href: '/home#quote' },
            { label: 'Contact / Waitlist', href: '/home#waitlist' }]?.
            map((link) =>
            <a
              key={link?.label}
              href={link?.href}
              onClick={() => setMenuOpen(false)}
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 700,
                fontSize: '16px',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                color: '#a0b0d8',
                textDecoration: 'none',
                padding: '13px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: 'rgba(0,245,255,0.03)',
                border: '1px solid rgba(0,245,255,0.08)',
                marginBottom: '4px'
              }}>

                {link?.label}
                <span style={{ color: '#00f5ff', fontSize: '14px' }}>→</span>
              </a>
            )}
          </nav>

          {/* CTA */}
          <div className="flex flex-col gap-2">
            <Link
              href="/waitlist"
              onClick={() => setMenuOpen(false)}
              style={{
                fontFamily: 'Barlow Condensed, Arial Narrow, Arial, sans-serif',
                fontWeight: 900,
                fontSize: '14px',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: '#050510',
                background: '#00f5ff',
                border: '2px solid #00f5ff',
                padding: '14px 20px',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                boxShadow: '0 0 20px rgba(0,245,255,0.4)'
              }}>

              <span>★</span> Join Waitlist — 15% OFF
            </Link>
            <Link
              href="/admin"
              onClick={() => setMenuOpen(false)}
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 700,
                fontSize: '11px',
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                color: 'rgba(224,232,255,0.3)',
                textDecoration: 'none',
                textAlign: 'center',
                padding: '8px'
              }}>

              Admin
            </Link>
          </div>
        </div>
      </div>
    </header>);

}